// Light or dark on this device (design 01a 5, "테마"): the system's choice
// unless one is picked here. styles.css reads data-theme on <html>. Kept
// per browser like the text size.
import { readPref, writePref } from './prefs'

const KEY = 'hm.theme'

export const THEMES = [
  { value: 'system', label: '시스템 설정대로' },
  { value: 'light', label: '밝게' },
  { value: 'dark', label: '어둡게' },
] as const

export type Theme = (typeof THEMES)[number]['value']

const VALUES = THEMES.map((t) => t.value)

export function theme(): Theme {
  return readPref<Theme>(KEY, VALUES, 'system')
}

/** Sets the theme now (and remembers it when save is true). */
export function applyTheme(t: Theme, save = false): void {
  if (t === 'system') delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = t
  if (save) writePref(KEY, t)
}
